export default "__VITE_ASSET__3c879093__"